var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5909 16.5734H8.43191C4.3272 16.5734 1 13.2462 1 9.14189C1 5.03762 4.3272 1.70998 8.43191 1.70998H15.5685C19.6728 1.70998 23 5.03762 23 9.14189C23 13.2462 19.6728 16.5734 15.5685 16.5734L11.1423 21",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5909 16.5734H8.43191C4.3272 16.5734 1 13.2462 1 9.14189C1 5.03762 4.3272 1.70998 8.43191 1.70998H15.5685C19.6728 1.70998 23 5.03762 23 9.14189C23 13.2462 19.6728 16.5734 15.5685 16.5734L11.1423 21L10.5909 16.5734Z",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsFilled);
export default __webpack_public_path__ + "static/media/contact-us-filled.007ded7ba8363bfb0d6edab82089b704.svg";
export { ForwardRef as ReactComponent };